import { FC } from 'react'
import styled from 'styled-components'
import { ActivityFilter } from 'generated/graphql'
import Button from '@app.components/Button'
import Loading from '@app.components/Loading/Loading'
import { useFilterSubmitButton } from './FilterSubmitButton.module'

interface IFFilterSubmitButtonProps {
  onSubmit: (filterBy: ActivityFilter) => void
  className?: string
  filterType: 'calender' | 'activity'
}

const FilterSubmitButton: FC<IFFilterSubmitButtonProps> = ({
  onSubmit,
  className,
  filterType,
}) => {
  const { count, loading, getFilterBy } = useFilterSubmitButton(filterType)

  const handleSubmit = () => {
    const filterBy = getFilterBy()
    onSubmit(filterBy)
  }

  return (
    <StyledWrapper
      onClick={handleSubmit}
      className={className}
      disabled={loading}
    >
      {loading ? (
        <>
          <Loading className="loading" />
          <span>건의 </span>
        </>
      ) : (
        <span>{count}건의 </span>
      )}
      <span>공고 보기</span>
    </StyledWrapper>
  )
}

export default FilterSubmitButton

const StyledWrapper = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  padding: 13px;
  font-size: 16px;
  font-weight: bold;

  .loading {
    width: 18px;
    height: 18px;
    margin-right: 3px;
  }
`
